
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/articles/tag/[tag]",
      function () {
        return require("private-next-pages/articles/tag/[tag].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/articles/tag/[tag]"])
      });
    }
  